import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FamilyConcernType = {
  id: string | null;
  concernsComment: string | null;
  prioritiesComment: string | null;
  materialResourceComment: string | null;
  informationalResourceComment: string | null;
  supportiveResourceComment: string | null;
  sessionReviewedDate: string | null;
};

export type IfspReportFamilyConcernType = {
  ifspId: string | null;
  familyConcerns: FamilyConcernType[];
  heldBy: string | null;
  isCurrentlyHeld: boolean;
};

export type IfspReportFamilyConcernStateType = {
  originalIfspFamilyConcernReport: IfspReportFamilyConcernType;
  ifspFamilyConcernReport: IfspReportFamilyConcernType;
};

export const initialIfspFamilyConcernReportState: IfspReportFamilyConcernStateType =
  {
    originalIfspFamilyConcernReport: {
      ifspId: null,
      familyConcerns: [],
      heldBy: null,
      isCurrentlyHeld: false,
    },
    ifspFamilyConcernReport: {
      ifspId: null,
      familyConcerns: [],
      heldBy: null,
      isCurrentlyHeld: false,
    },
  };

const ifspFamilyConcernSlice = createSlice({
  name: 'ifspFamilyConcernReport',
  initialState: initialIfspFamilyConcernReportState,
  reducers: {
    setIfspFamilyConcernReport: (
      state,
      action: PayloadAction<IfspReportFamilyConcernType>,
    ) => {
      state.ifspFamilyConcernReport = action.payload;
      state.originalIfspFamilyConcernReport = action.payload;
    },
    updateIfspFamilyConcernReport: (
      state,
      action: PayloadAction<Partial<IfspReportFamilyConcernType>>,
    ) => {
      state.ifspFamilyConcernReport = {
        ...state.ifspFamilyConcernReport,
        ...action.payload,
      };
    },
    updateOriginalIfspFamilyConcernReport: (
      state,
      action: PayloadAction<Partial<IfspReportFamilyConcernType>>,
    ) => {
      state.originalIfspFamilyConcernReport = {
        ...state.originalIfspFamilyConcernReport,
        ...action.payload,
      };
    },

    resetIfspFamilyConcernReport: () => initialIfspFamilyConcernReportState,
  },
  extraReducers: (builder) => {
    builder.addCase(
      'RESET_REDUX_APP_STATES',
      () => initialIfspFamilyConcernReportState,
    );
  },
});

export const {
  setIfspFamilyConcernReport,
  updateIfspFamilyConcernReport,
  updateOriginalIfspFamilyConcernReport,
  resetIfspFamilyConcernReport,
} = ifspFamilyConcernSlice.actions;

export default ifspFamilyConcernSlice.reducer;
